var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 24V48L64 56","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Clock.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
